export const fs = {
  footer: "w-full bg-black text-white pt-16 md:pt-24 pb-10 px-6 mt-auto",
  mainWrapper: "max-w-[1400px] mx-auto flex flex-col lg:flex-row lg:justify-between items-start lg:items-center gap-12 lg:gap-16 mb-16",
  logoSection: "w-full lg:w-auto flex-shrink-0 flex justify-center lg:justify-start",
  logoImg: "w-32 md:w-40 h-auto object-contain opacity-70 hover:opacity-100 transition-opacity",
  columnsContainer: "grid grid-cols-1 sm:grid-cols-2 gap-12 lg:gap-32 flex-grow",
  colStack: "space-y-4",
  colTitle: "text-[10px] font-black uppercase tracking-[0.2em] text-msc-green border-b border-white/10 pb-2 w-fit",
  list: "space-y-3 text-[12px] md:text-[13px] text-slate-400",
  link: "hover:text-white transition-colors cursor-pointer",
  actionWrapper: "w-full lg:w-auto flex justify-center lg:justify-end",
  actionBtn: "bg-msc-blue px-8 py-4 rounded-xl font-black text-[10px] uppercase tracking-widest hover:brightness-110 transition-all",
  bottomBar: "max-w-[1400px] mx-auto pt-10 border-t border-white/5 flex flex-col md:flex-row justify-between items-center gap-6",
  copyright: "text-[8px] text-slate-600 uppercase tracking-widest font-bold",
  socialWrapper: "flex gap-8",
  socialIcon: "text-slate-500 hover:text-msc-green transition-all"
};